const routes = [
  {
    path: 'scholarship',
    name: 'scholarship',
    component: () => import('@/views/scholarship/ScholarshipWrapper.vue'),
    children: [
      {
        path: '/scholarship/menu',
        name: 'scholarship',
        component: () => import('@/views/scholarship/Menu.vue'),
      },
      {
        path: '',
        name: 'AttendanceWrapper',
        component: () => import('@/views/scholarship/attendance/Wrapper.vue'),
        children: [
          {
            path: '/sholarship/paymentmanagement',
            name: 'ScholarshipAttendance',
            component: () => import('@/views/scholarship/attendance/Main.vue'),
          },
          {
            path: '/scholarship/pei-information',
            name: 'PeiInformation',
            component: () =>
              import('@/views/scholarship/pei-information/Main.vue'),
          },
        ],
      },
      {
        path: '/scholarship/budget',
        name: 'Budget',
        component: () => import('@/views/scholarship/budget/Main.vue'),
      },
      {
        path: '/scholarship/loadingprocess',
        name: 'LoadingProcess',
        component: () => import('@/views/scholarship/loadingProcess/Main.vue'),
      },
      {
        path: 'jornalpayment',
        component: () =>
          import('@/views/scholarship/jornalPayment/Wrapper.vue'),
        children: [
          {
            path: '/sholarship/jornalpayment',
            name: 'jornalpayment',
            component: () =>
              import('@/views/scholarship/jornalPayment/Main.vue'),
          },
          {
            path:
              '/sholarship/jornalpayment/details/:academicYearId/:paymentJournalId',
            name: 'jornalDetails',
            component: () =>
              import('@/views/scholarship/jornalPayment/Details.vue'),
          },
        ],
      },
      {
        path: '/sholarship/cardhandling',
        name: 'cardHandling',
        component: () => import('@/views/scholarship/cardHandling/Main.vue'),
      },
    ],
  },
];

export default routes;
